import React from "react";

import "./Preloader.css";

// TODO: review how this is used

export const Preloader: React.FunctionComponent = () => (
	<div className="preloader" />
);

export const FullCardPreloader: React.FunctionComponent = () => (
	<div className="full-card-preloader">
		<Preloader />
	</div>
);

export const FullPagePreloader: React.FunctionComponent = () => (
	<div className="full-page-preloader">
		<Preloader />
	</div>
);
